const state = {
  globalLoading: 0,
  errorMessage: null,
  errorSnackbar: null,
  successMessage: null,
  successSnackbar: null,
};

// getters
const getters = {
  showGlobalLoading: state => {
    return state.globalLoading > 0;
  },
};

// actions
const actions = {
  reload({ commit }) {
    // commit('presentGlobalLoading');
    // Inertia.reload().then(() => commit('dismissGlobalLoading'), () => commit('dismissGlobalLoading'));
  },
};

// mutations
const mutations = {
  presentGlobalLoading(state) {
    state.globalLoading = state.globalLoading + 1;
  },
  dismissGlobalLoading(state) {
    state.globalLoading = state.globalLoading - 1;
  },
  errorToast(state, message) {
    state.errorMessage = message;
    state.errorSnackbar = true;
  },
  setErrorSnackbar(state, snackbar) {
    state.errorSnackbar = snackbar;
  },
  successToast(state, message) {
    state.successMessage = message || 'Operación realizada con éxito';
    state.successSnackbar = true;
  },
  setSuccessSnackbar(state, snackbar) {
    state.successSnackbar = snackbar;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
